import { PackingListProductSkuModel } from '@core/app/scripts/classes/packing-list-product-sku-model';
import { isObject } from 'util';
import { merge } from 'angular';
import { ILegacyColorId, getUniqueColors } from '@classes/legacy-color';
import { flow, uniqBy, sortBy, map } from 'lodash';

/**
 * Class for PackingListProduct. Related to {@link ProductObject}
 */
export class PackingListProductModel {
  skus: PackingListProductSkuModel[];
  articleCode: string;

  constructor(originalValue?: any) {
    if (isObject(originalValue)) {
      merge(this, originalValue);
    }
  }

  /**
   * Returns an array of color objects based on the available colors in the product
   * ```
   * [
   *  {
   *    colorDescription: 'blue',
   *    colorCode: '001'
   *  }
   * ]
   * ```
   * @returns {array<object>} array of color objects
   */
  getColors(): ILegacyColorId[] {
    return getUniqueColors(this.skus);
  }

  /**
   * Returns an array of color objects based on the available colors in the product
   * ```
   * [ 's', 'm', 'l' ]
   * ```
   * @returns {strigt[]} array of sizes
   */
  getSizes(): string[] {
    return flow([
      (x) => uniqBy(x, 'size'),
      (x) => sortBy(x, 'sizeIndex'),
      (x) => map(x, (x) => x.size),
    ])(this.skus);
  }
}
